import React, { useContext } from 'react';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { AppContext, IAppContext } from 'appState/appContext';
import { IWordingsContext, WordingsContext } from '../../wordingsState/wordingsContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { convertUndefinedFields } from 'utils/helpers';
import { updateWordings } from 'backend/adminSettings';

export const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { changeTypeOfModalWindow, removeWording, dataForSubmit, deleteWordingData, typeOfModalWindow } =
		useContext<IWordingsContext>(WordingsContext);

	const handleConfirm = async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await updateWordings(convertedData);
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	};

	const handleDelete = () => {
		if (deleteWordingData) {
			removeWording(deleteWordingData.groupId, deleteWordingData.wordingId);
		}
	};

	const handleCloseModal = () => {
		changeTypeOfModalWindow(null);
	};

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			<ModalToConfirm
				onConsentEvent={handleDelete}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmDeleteItem'}
				description="deleteWording"
				typeOfInfoIcon="toDelete"
			/>
			<ModalToConfirm
				onConsentEvent={handleCloseModal}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalToConfirm
				onConsentEvent={handleConfirm}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmSubmit'}
				description="saveInfo"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
		</ModalWrapper>
	);
};
